
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","x":"20","y":"20","viewBox":"0 0 297 297"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M250.929 276.619h-17.463v-31.301c0-31.668-17.379-60.777-48.936-81.967-3.924-2.635-6.363-8.324-6.363-14.852s2.439-12.215 6.365-14.852c31.555-21.188 48.934-50.297 48.936-81.965V20.381h17.461c5.627 0 10.189-4.562 10.189-10.191 0-5.629-4.562-10.19-10.189-10.19H46.071c-5.627 0-10.19 4.561-10.19 10.189 0 5.629 4.563 10.191 10.19 10.191h17.463v31.303c0 31.668 17.377 60.777 48.936 81.965 3.924 2.637 6.363 8.324 6.363 14.852 0 6.529-2.439 12.217-6.365 14.854-31.557 21.188-48.934 50.297-48.934 81.965v31.301H46.071c-5.627 0-10.19 4.563-10.19 10.191 0 5.629 4.563 10.19 10.19 10.19h204.857c5.627 0 10.189-4.56 10.189-10.19.001-5.629-4.561-10.192-10.188-10.192zM83.915 245.318c0-33.275 25.006-55.035 39.914-65.043 9.633-6.467 15.385-18.346 15.385-31.775 0-13.428-5.752-25.307-15.385-31.773-14.908-10.008-39.914-31.768-39.914-65.043V20.381h129.17l-.002 31.303c0 33.275-25.006 55.035-39.912 65.041-9.635 6.469-15.387 18.348-15.387 31.775 0 13.43 5.752 25.307 15.385 31.775 14.908 10.008 39.914 31.768 39.916 65.043v31.301H83.915v-31.301z"}})])
          )
        }
      }
    